<template>
  <div>
    <el-date-picker
      v-model="pickerValue"
      :type="type"
      :size="size"
      :readonly="readonly"
      range-separator="По"
      start-placeholder="Дата начала"
      end-placeholder="Дата окончания"
      :picker-options="pickerOptions"
      @change="onChange"
    />
  </div>
</template>

<script>
import { formatDateToRFC3339WithoutTimezone, formatDate } from "@/utils";

export default {
  props: {
    value: {
      type: [String, Array, Date],
      required: false,
      default: null,
    },
    type: {
      type: String,
      default: "date",
    },
    size: {
      type: String,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pickerOptions: {
        firstDayOfWeek: 1,
      },
    };
  },
  computed: {
    pickerValue: {
      get() {
        if (this.value && Array.isArray(this.value)) {
          if (this.type === "daterange") {
            return this.value.map((e) => formatDate(e));
          }
          return this.value.map((e) => formatDateToRFC3339WithoutTimezone(e));
        }
        return this.value;
      },
      set(val) {
        if (val && Array.isArray(val)) {
          if (this.type === "daterange") {
            val = val.map((e) => formatDate(e));
          } else {
            val = val.map((e) => formatDateToRFC3339WithoutTimezone(e));
          }
        }

        this.$emit("input", val ? val : ["", ""]);
      },
    },
  },
  methods: {
    onChange() {
      this.$emit("change", this.pickerValue);
    },
  },
};
</script>
